import { useContext } from 'react';
import './accDrop.css';
import { UserAuthContext } from '../../../context/UserAuthContext';
import { ReactComponent as LanguageIcon } from '../../../assets/icons/trvto_language.svg';
import { ReactComponent as CurrencyIcon } from '../../../assets/icons/trvto_currency.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/trvto_arrowRightWhiteBlack.svg';
import { Link, useNavigate } from 'react-router-dom';
import { useTempOrg } from '../../../context/TempOrgContext';

export default function AccDrop({ setAccountDrop, setLogButton, setLoginSec }) {
    const { isAuthenticated, logout } = useContext(UserAuthContext);
    const navigate = useNavigate();
    const { tempOrg } = useTempOrg();
    const { id } = tempOrg;
    return (
        <div className='accDropDiv'>
            <div className='alignCenter' style={{ gap: '8px' }}>
                <button className='outlinedBtn'>
                    <LanguageIcon /> English
                </button>
                <button className='outlinedBtn'>
                    <CurrencyIcon /> ₹
                </button>
            </div>
            {window.location.pathname !== '/' && !id && (
                <button type='button' name='login' className='listButton' onClick={() => navigate('/')}>
                    Home <ArrowRight className='arrowDrop' />
                </button>
            )}
            {!isAuthenticated && (
                <div className='list'>
                    <button type='button' name='login' className='listButton' onClick={() => setLogButton(true)}>
                        Login <ArrowRight className='arrowDrop' />
                    </button>
                    <button
                        type='button'
                        name='signup'
                        className='listButton'
                        onClick={() => {
                            setLogButton(true);
                            setLoginSec('register');
                        }}
                    >
                        Sign Up <ArrowRight className='arrowDrop' />
                    </button>
                    {/* <Link>
            Accomodation <ArrowRight className="arrow" />
          </Link>
          <Link>
            Explore TrvTo <ArrowRight className="arrow" />
          </Link> */}
                    {window.location.pathname !== '/' && !id && (
                        <Link to='/org/login'>
                            List Your Trips <ArrowRight className='arrowDrop' />
                        </Link>
                    )}
                    <Link to='/contact-us'>
                        Contact Us <ArrowRight className='arrowDrop' />
                    </Link>
                    <Link to='/faq'>
                        FAQ <ArrowRight className='arrowDrop' />
                    </Link>
                </div>
            )}
            {isAuthenticated && (
                <div className='list'>
                    <Link to='/my-wishlist'>
                        My Wishlist <ArrowRight className='arrowDrop' />
                    </Link>
                    <Link to='/my-booking'>
                        My Booking <ArrowRight className='arrowDrop' />
                    </Link>
                    {!id && (
                        <>
                            <Link to='/contact-us'>
                                Contact Us <ArrowRight className='arrowDrop' />
                            </Link>
                            <Link to='/faq'>
                                FAQ <ArrowRight className='arrowDrop' />
                            </Link>
                        </>
                    )}

                    {window.location.pathname !== '/' && !id && (
                        <Link to='/org/login'>
                            List Your Trips <ArrowRight className='arrowDrop' />
                        </Link>
                    )}
                    <Link to='/account'>
                        Profile <ArrowRight className='arrowDrop' />
                    </Link>
                    <button
                        type='button'
                        onClick={() => {
                            setAccountDrop(false);
                            logout();
                        }}
                        name='mybooking'
                        className='listButton'
                    >
                        Logout <ArrowRight className='arrowDrop' />
                    </button>
                </div>
            )}
        </div>
    );
}
